import { render, staticRenderFns } from "./MenuPanel.vue?vue&type=template&id=dd795bc6&scoped=true&"
import script from "./MenuPanel.vue?vue&type=script&lang=js&"
export * from "./MenuPanel.vue?vue&type=script&lang=js&"
import style0 from "./MenuPanel.vue?vue&type=style&index=0&id=dd795bc6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd795bc6",
  null
  
)

export default component.exports